import { createApp } from '@app/adapters/create-app'

import CompanyInbox from '../../screens/inbox/components/company-inbox'
import CompanyInboxV2 from '@app/application/communication/screens/inbox/components/company-inbox-v2.vue'
import { startOnce } from '@app/adapters/tutorial'
import createStore from '../../screens/inbox/store/inbox'
import createInboxV2Store from '@app/application/communication/screens/inbox/store/inbox-v2'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='company-inbox']").each(function () {
    const endpointParams = {
      companyId: Silverfin.currentCompanyId,
      ledgerId: Silverfin.currentLedgerId(),
      firmId: Silverfin.currentFirmId,
    }

    let store
    let companyInboxApp
    if (Silverfin.currentFirmFeatures.supports_communications_rework) {
      companyInboxApp = createApp(CompanyInboxV2)
      store = createInboxV2Store(endpointParams)
    } else {
      companyInboxApp = createApp(CompanyInbox, {
        companyName: this.getAttribute('data-company-name'),
      })
      store = createStore(endpointParams)
    }
    companyInboxApp.use(store)
    companyInboxApp.mount(this)

    /* TODO: Manually trigger the corresponding Userlane tutorial until they fix their JS performance
    See https://gitlab.silverfin.com/development/silverfin/-/issues/18067 */
    if (typeof this.dataset.tutorialId !== 'undefined') {
      startOnce(this.dataset.tutorialId)
    }

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        showAuthorsFilter: true,
      })
      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
